import axios from 'axios'
import React, { useState, useEffect } from 'react'
import { ProductCard } from './ProductCard'

const ProductSelection = ({
  userId,
  token,
  url,
  purchasedPhysical,
  physical,
  sst,
  gpTrack,
  purchasedGpTrack,
  gpTrackWorkshop,
  purchasedGpTrackWorkshop,
  educationTrack,
  purchasedEducationTrack,
  userMemberType,
}) => {
  const [selected, setSelected] = useState(null)
  const [selectedGpTrack, setSelectedGpTrack] = useState(null)
  const [selectedGpTrackWorkshop, setSelectedGpTrackWorkshop] = useState(null)
  const [selectedEducationTrack, setSelectedEducationTrack] = useState(null)

  const productIds = [
    selected,
    selectedGpTrack,
    selectedGpTrackWorkshop,
    selectedEducationTrack,
  ]

  const isGeneralPractitioner = userMemberType === 'general_practitioner'
  const eligibleForEducationTrack =
    userMemberType === 'master_officer' || userMemberType === 'assistant'

  return (
    <div id="productSelection">
      <form action={url} method="POST">
        <input type="hidden" name="authenticity_token" value={token} />
        <input type="hidden" name="product_ids" value={productIds} />

        {/* Show physical and education tracks products for non-GP members, only can select one */}
        {!isGeneralPractitioner && (
          <>
            {!purchasedEducationTrack && (
              <ProductCard
                cardTitle={'55th MOA ASM 2026 Conference Ticket'}
                products={physical}
                selectedState={selected}
                setSelectedState={setSelected}
                activated
                handleCheckbox={(e) => {
                  if (!e.target.checked) {
                    setSelected(null)
                  }
                }}
                handleRadio={() => {
                  setSelectedEducationTrack(null)
                }}
              />
            )}

            {eligibleForEducationTrack && !purchasedPhysical && (
              <>
                <h4 className="text-navy text-center mt-4">OR</h4>
                <h4 className="text-navy text-center mt-4">
                  Select Education Track 1-Day Ticket
                </h4>
                <small className="text-center d-block mb-4">
                  *Only open to Master Student / Medical Officer / House Officer
                  / Research Assistant
                </small>

                <ProductCard
                  cardTitle={
                    '55th MOA ASM 2026 Education Track - 19th May 2025'
                  }
                  products={educationTrack}
                  selectedState={selectedEducationTrack}
                  setSelectedState={setSelectedEducationTrack}
                  activated
                  handleCheckbox={(e) => {
                    if (!e.target.checked) {
                      setSelectedEducationTrack(null)
                    }
                  }}
                  handleRadio={() => {
                    setSelected(null)
                  }}
                />
              </>
            )}
          </>
        )}

        {/* Show GP Track products only for GP members */}
        {isGeneralPractitioner && (
          <>
            <ProductCard
              cardTitle={
                '55th MOA ASM 2026 GP Track Symposium Sessions Registration'
              }
              products={gpTrack}
              selectedState={selectedGpTrack}
              setSelectedState={setSelectedGpTrack}
              activated
              handleCheckbox={(e) => {
                if (!e.target.checked) {
                  setSelectedGpTrack(null)
                  setSelectedGpTrackWorkshop(null)
                }
              }}
              handleRadio={() => {
                setSelectedGpTrackWorkshop(null)
              }}
            />

            <ProductCard
              cardTitle={
                '55th MOA ASM 2026 GP Track Workshop Registration - Limited Slots Available (Add on)'
              }
              products={gpTrackWorkshop}
              selectedState={selectedGpTrackWorkshop}
              setSelectedState={setSelectedGpTrackWorkshop}
              activated={selectedGpTrack || purchasedGpTrack}
              handleCheckbox={(e) => {
                if (!e.target.checked) {
                  setSelectedGpTrackWorkshop(null)
                }
              }}
              handleRadio={() => {}}
            />
          </>
        )}

        <strong className="d-block mx-auto">
          All purchases will incur 8% SST
        </strong>

        <button
          type="submit"
          className="btn text-white btn-primary d-block mx-auto mt-4"
          disabled={
            selected === null &&
            selectedGpTrack === null &&
            selectedGpTrackWorkshop === null &&
            selectedEducationTrack === null
          }
        >
          Purchase Pass
        </button>
      </form>
    </div>
  )
}

export default ProductSelection
